import { render, staticRenderFns } from "./Postcards.vue?vue&type=template&id=70857b2c"
import script from "./Postcards.vue?vue&type=script&lang=js"
export * from "./Postcards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports